import { render, staticRenderFns } from "./PubTravels.vue?vue&type=template&id=e9d8b882&scoped=true"
import script from "./PubTravels.vue?vue&type=script&lang=js"
export * from "./PubTravels.vue?vue&type=script&lang=js"
import style0 from "./PubTravels.vue?vue&type=style&index=0&id=e9d8b882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d8b882",
  null
  
)

export default component.exports